import React, { useState, useEffect } from "react";
import axios from "axios";
import { env as environment } from "../controllers/environment";
import { useContext } from "react";
import { Context } from "../context";
import Header from "./Header";
import Footer from "./Footer";
import { useNavigate, useLocation } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";
import NavigateIcon from "../assets/navigate.png";
import ls from "localstorage-slim";

ls.config.encrypt = true;
const Confirmation = () => {
	const navigate = useNavigate();
	const { setData, inputEmail, setButtonStatus } = useContext(Context);
	const [spinner1, setSpinner1] = useState(false);
	const [spinner2, setSpinner2] = useState(false);
	const location = useLocation();

	useEffect(() => {
		if (!inputEmail) navigate("/");
		// if (extraButton) scrollToBottom();
	}, []);

	const handleContinue = async (e) => {
		e.preventDefault();
		setSpinner1(true);
		const json = { email: inputEmail, apikey: environment.apikey };
		await axios.post(environment.verifycontinue, json).then((res) => {
			setButtonStatus(res?.data?.data);
			ls.set("buttonstatus", JSON.stringify(res?.data?.data));
			console.log("verifyContinue", res.data);
			navigate("/buttons/" + inputEmail);
		});
	};
	const handleFresh = async (e) => {
		e.preventDefault();
		setSpinner2(true);
		const json = { email: inputEmail, apikey: environment.apikey };
		await axios.post(environment.startfresh, json).then((res) => {
			console.log("startFresh", res.data);
			// setData(res.data);
			setButtonStatus(res?.data?.data);
			localStorage.setItem("buttonstatus", JSON.stringify(res?.data?.data));
			setTimeout(() => {
				navigate("/buttons/" + inputEmail);
			}, 1000);
		});
	};

	return (
		<div className="parent">
			{/* <Header /> */}
			<div className="back_btn">
				{location.pathname !== "/" ? <img className="navigate-img" src={NavigateIcon} alt="Go back" onClick={() => navigate("/")} /> : ""}
			</div>
			<div className="main-container">
				<div className="confirmation-box">
					Your account already exists. Are you sure you want to start a <span className="font-green">new</span> verification?
					<div className="confirmation-btn-container">
						<button className="confirmation-btn" onClick={handleContinue}>
							{spinner1 ? (
								<RotatingLines strokeColor="white" strokeWidth="4" animationDuration="0.75" width="25" visible={true} />
							) : (
								"Continue with existing "
							)}
						</button>
						<button className="confirmation-btn" onClick={handleFresh}>
							{spinner2 ? (
								<RotatingLines strokeColor="white" strokeWidth="4" animationDuration="0.75" width="25" visible={true} />
							) : (
								"Yes, start fresh"
							)}
						</button>
					</div>
				</div>
			</div>
			<Footer />
		</div>
	);
};

export default Confirmation;
